import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { LeftArrow } from '@HomaHealth/ui-component-library';
import Svg404Error from '../../_components/atoms/Icons/404Error';
import componentConstants from '../../core-utils/messages/componentConstants';
import { useNavigate, useLocation } from 'react-router-dom';
import { DottedText } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { LOGIN } from '../../core-utils/routes';

interface HistoryState {
  from: string;
  error?: string;
  error_description?: string;
}

const ErrorPage = () => {
  const { classes } = makeStyles()({
    root: {
      width: '627px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
      alignItems: 'center',
    },
  })();
  const [error, setError] = useState<String>('');
  const [errorDescription, setErrorDescription] = useState<String>('');

  const pageConstants = componentConstants.PAGES.ERROR_PAGE;

  const navigate = useNavigate();
  const location = useLocation();
  const historyState = location.state as HistoryState;

  useEffect(() => {
    if (historyState?.error) {
      setError(historyState?.error || '');
      setErrorDescription(historyState?.error_description || '');
    }
  }, []);

  return (
    <Grid container className={classes.root}>
      <Grid style={{ margin: '30px 0px' }}>
        <Svg404Error width="338px" height="250px" />
      </Grid>
      <Grid style={{ marginBottom: '16px' }}>
        <Typography
          fontSize="28px"
          lineHeight="45px"
          fontType="medium"
          textColor={patientAccessTheme.palette.text.highemphasis}
        >
          {error ? error : pageConstants.PAGE_NOT_FOUND}
        </Typography>
      </Grid>
      <Grid style={{ marginBottom: '28px', textAlign: 'center' }}>
        <Typography
          fontSize="16px"
          lineHeight="29px"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
        >
          {errorDescription ? errorDescription : pageConstants.INFO}
        </Typography>
      </Grid>
      <Grid
        container
        style={{ cursor: 'pointer', width: 'fit-content' }}
        onClick={() => {}}
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid style={{ height: '14px', width: '14px', marginRight: '8px' }}>
          <LeftArrow
            height="14px"
            width="14px"
            fill={patientAccessTheme.palette.primary.main}
          />
        </Grid>
        {error ? (
          <Grid onClick={() => navigate(LOGIN)}>
            <DottedText text={pageConstants.LOGIN_PAGE} />
          </Grid>
        ) : (
          <Grid onClick={() => navigate(historyState.from)}>
            <DottedText text={pageConstants.GO_BACK} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
